import { Box, HStack, IconButton, Pressable, Text, View } from '@rbilabs/universal-components';

export const borderRadius = 10;

export interface IMethodContainer {
  disableHover?: boolean;
  disableMethod?: boolean;
  hideBorder?: boolean;
  fromCheckout?: boolean;
  $isClickable?: boolean;
}
export const MethodContainer = HStack.withConfig<IMethodContainer>({
  flex: 1,
  alignItems: 'center',
  minHeight: '$13.5',
  padding: '$2',
});

export const MethodTypeWrapper = Pressable.withConfig<IMethodContainer>(({ fromCheckout }) => ({
  flex: 1,
  ...(!fromCheckout && {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '$1', // keep at $1 for a11y
  }),
}));

export const MethodTypeInnerWrapper = HStack.withConfig({
  flex: 1,
  flexWrap: 'wrap',
});

export const MethodType = Text;

export const TextContainer = View.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
});

export const DeleteIconButton = IconButton.withConfig({
  _pressed: {
    style: {
      transform: [{ scale: 1.05 }],
    },
  },
});

export const PaymentNotAvailableContainer = Pressable.withConfig<{
  isCollapsed?: boolean;
}>(p => ({
  flexDirection: 'row',
  padding: 0,
  alignItems: 'center',
  backgroundColor: 'token.background-inline-alert-error',
  _web: {
    cursor: 'pointer',
  },
  paddingRight: '$5',
  paddingLeft: '$2',
  height: '$9',
  borderBottomRightRadius: p.isCollapsed ? borderRadius : 0,
  borderBottomLeftRadius: p.isCollapsed ? borderRadius : 0,
}));

export const PaymentNotAvailableText = Box.withConfig({
  flex: 1,
  width: 'full',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const PaymentNotAvailableMessage = Box.withConfig({
  width: '2/3',
  _text: {
    color: 'token.background-button-primary-pressed',
    fontSize: 'md',
  },
  marginLeft: '$2',
});

export const PaymentNotAvailableLink = Box.withConfig({
  paddingTop: '$1',
  paddingRight: '$2',
  _text: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'token.background-button-primary-pressed',
  },
});
